import type { StaffMessage, StaffMessageReach } from '../types.js'

/** Two SMS segments (SMS plan D3). */
export const STAFF_MESSAGE_MAX_LENGTH = 320

/** The facility's name and the link ride with the text; a text that long is GSM-7 or not by its characters. */
const GSM7 = /^[A-Za-z0-9@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#%&'()*+,\-./:;<=>?¡ÄÖÑÜ§¿äöñüà\n\r\f^{}\\[~\]|€]*$/

/** How many segments a text of this length goes as, the facility's name and the STOP line beside it (about 60 characters more). */
export function smsSegmentsOf(text: string): number {
  const length = text.length + 60
  const gsm = GSM7.test(text)
  const single = gsm ? 160 : 70
  const each = gsm ? 153 : 67
  return length <= single ? 1 : Math.ceil(length / each)
}

/** "14 in app · 9 texted · 3 held · 2 no number". */
export function describeReach(reach: StaffMessageReach): string {
  const parts = [`${reach.inApp} in app`, reach.texted ? `${reach.texted} texted` : null, reach.held ? `${reach.held} held` : null, reach.skipped ? `${reach.skipped} not texted` : null, reach.failed ? `${reach.failed} failed` : null, reach.noNumber ? `${reach.noNumber} no number` : null]
  return parts.filter(Boolean).join(' · ')
}

/** "CNAs", "Gold RNs on Unit A", "everyone", or "1 worker": the unit by the facility's name for it where `units` has it. */
export function describeRecipients(message: StaffMessage, units: ReadonlyMap<string, string> = new Map()): string {
  if ('workerIds' in message.to) {
    return message.count === 1 ? '1 worker' : `${message.count} workers`
  }
  const { role, tier, unitId, employmentType } = message.to.filter
  const words = [tier ? tier[0]?.toUpperCase() + tier.slice(1) : null, employmentType ? employmentType.replace('_', ' ') : null, role ? `${role}s` : null, unitId ? `on ${units.get(unitId) ?? unitId}` : null].filter(Boolean)
  return words.length === 0 ? `everyone (${message.count})` : `${words.join(' ')} (${message.count})`
}

export function formatSentAt(iso: string): string {
  return new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}
